import axiosApi from "../../components/Api/Axios";
import BackendServices from "../../components/Api/BackendService";
import { details as detailsPath } from "../../components/Paths/paths";
import VerifyDetailsView from "../../Models/Verify/Models/VerifyAuditDetailsView";

export default (id: string | number) =>
  axiosApi.get<VerifyDetailsView>(
    `${BackendServices.AUDIT_SERVICE.VERIFY}/${id}${detailsPath}`
  );